import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import fontawesome
import {BrowserRouter} from 'react-router-dom'
import ReactDOM from 'react-dom/client';
import 'bulma/css/bulma.css';
import "@fontsource/montserrat";
import './index.css';
// import 'react-bulma-components/dist/react-bulma-components.min.css';
import 'bulma-calendar/dist/css/bulma-calendar.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
